/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */

import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ZSDTranslateService } from './../../../../../common/zsd-translate.service';
import { QuickCallService } from './../service/quickcalllist.service';
import { QuickCallBasicInfo, QuickCallResponse } from './../model/quickcallresponse';
import { SpinnerService } from '../../../../../shared/spinner/spinner.service';
import { BannerComponent } from '../../../../view/banner/banner.component';


declare var $: any;

@Component({
    selector: 'zsd-quickcalllist',
    templateUrl: '../view/quickcalllist.component.html',
    styleUrls: ['../view/quickcalllist.component.scss']
})

export class QuickCallListComponent implements OnInit {
  sortByDefault = 'name';
  isLoading = false;
  searchQuickCall: string;
  scrollEndReached = false;
  isDesc = true;
  sortColumn: string;
  sortOrder = -1;
  quickCallId: number;
  quickCallType: string;
  quickCallTypeKey: string;
  quickCallName: string;
  quickCallBasicInfoResponse = new Array<QuickCallBasicInfo>();
  quickCallListResponse: QuickCallResponse = new QuickCallResponse();
  spinnerStart = true; // adding for showing spinner while loading instead of No request message

  constructor(public quickCallService: QuickCallService,
    public zsdTranslate: ZSDTranslateService, public http: HttpClient,
    public spinnerService: SpinnerService) {
  }


  ngOnInit() {
    /* To refresh Global search dropdown */
    BannerComponent.refreshGlobalSearchDropdown.next(false);
    this.initializeItemsParameters();
    this.getQuickCallList();
    this.sort(this.sortByDefault);
  }


  sort(property) {
    $('#property').removeClass('fa fa-sort');
    this.isDesc = !this.isDesc;
    this.sortColumn = property;
    this.sortOrder = this.sortOrder * (-1);
  }

  getQuickCallList() {
    if (this.quickCallBasicInfoResponse != null && this.quickCallBasicInfoResponse.length > 0) {
      this.isLoading = false;
      this.spinnerStart = false;
      return this.quickCallBasicInfoResponse;
    }
    if (!this.isLoading) {
      this.isLoading = true;
      this.spinnerService.show();
      this.quickCallService
        .getQuickCallList()
        .subscribe(
          (quickCallResponse: QuickCallResponse) => {
            if (quickCallResponse.resultCount > 0) {
              this.quickCallBasicInfoResponse = quickCallResponse.results;
            }
            this.isLoading = false;
            this.spinnerStart = false;
          },
          err => {
            console.error(err.error);
            this.isLoading = false;
            this.spinnerStart = false;
          }
        );
    }
  }
  // @HostListener('window:beforeunload', ['$event']) unloadHandler() {
  //   new QuickCallListComponent(
  //       this.quickCallService,
  //       this.route,  this.zsdTranslate,  this.http,
  //       this.spinnerService );
  //   window.scrollTo(0, 0);
  // }
  initializeItemsParameters() {
    this.isLoading = false;
    this.quickCallBasicInfoResponse = [];
    this.quickCallListResponse = new QuickCallResponse();
  }
  getQuickCallinfo(quickCall) {
    this.quickCallId = quickCall.quickCallId;
    this.quickCallType = quickCall.quickCallType;
    this.quickCallName = quickCall.name;
    this.quickCallTypeKey = quickCall.typeKey;
  }
  resetQuickCall() {
    this.quickCallId = null;
    this.quickCallType = null;
    this.quickCallTypeKey = null;
  }

  getQuickCallItemName(quickCall: QuickCallBasicInfo): string {
    if (quickCall.itemsInfo) {
      if (quickCall.itemsInfo.length > 0) {
        return quickCall.itemsInfo.map(item => item.itemName).join(', ');
      } else {
        return '';
      }
    }
    return '';
  }
}
